import { render, staticRenderFns } from "./tabPendidikanProfil.vue?vue&type=template&id=8e266428"
import script from "./tabPendidikanProfil.vue?vue&type=script&lang=js"
export * from "./tabPendidikanProfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports